/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Chip de período visible junto a Filtros — muestra el rango activo
 * ("Hoy", "Este mes", "01/09 – 30/09") y abre el picker de período.
 */
import React from 'react';
import { StyleSheet, Text, TouchableOpacity, type StyleProp, type ViewStyle } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { ticketColors, ticketFonts } from '../../shared/theme/public-api';

type Props = {
  label: string;
  onPress: () => void;
  /** `desk`: PC compacto. `ticket`: mobile, expande en la fila. */
  variant?: 'desk' | 'ticket';
  style?: StyleProp<ViewStyle>;
  testID?: string;
};

export function SalesPeriodChip({ label, onPress, variant = 'desk', style, testID }: Props) {
  return (
    <TouchableOpacity
      style={[styles.chip, variant === 'ticket' && styles.chipTicket, style]}
      onPress={onPress}
      activeOpacity={0.55}
      accessibilityRole="button"
      accessibilityLabel={`Período: ${label}`}
      testID={testID}
    >
      <Ionicons name="calendar-outline" size={15} color={ticketColors.ink3} />
      <Text style={styles.label} numberOfLines={1}>
        {label}
      </Text>
      <Ionicons name="chevron-down" size={14} color={ticketColors.ink3} />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    height: 42,
    paddingHorizontal: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.tile,
  },
  chipTicket: {
    flex: 1,
    marginBottom: 0,
  },
  label: {
    fontSize: 13,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
    flexShrink: 1,
  },
});
